import { PartnerProviderType } from "@/types/partner-settings";

export enum PartnerProviderLogEventType {
  SYNC_STARTED = "SYNC_STARTED",
  SYNC_COMPLETED = "SYNC_COMPLETED",
  SYNC_FAILED = "SYNC_FAILED",
  API_FAILED = "API_FAILED",
  MANUAL_SYNC_TRIGGERED = "MANUAL_SYNC_TRIGGERED",
}

export enum PartnerProviderLogStatus {
  INFO = "INFO",
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}

export enum PartnerProviderLogLevel {
  INFO = "INFO",
  WARN = "WARN",
  ERROR = "ERROR",
}

export interface PartnerProviderLog {
  id: string;
  provider: PartnerProviderType | string;
  hotelId: string | null;
  tenantId: string | null;
  eventType: PartnerProviderLogEventType | string;
  status: PartnerProviderLogStatus | string;
  level: PartnerProviderLogLevel | string;
  operation: string | null;
  message: string | null;
  durationMs: number | null;
  httpStatus: number | null;
  errorCode: string | null;
  details: unknown;
  createdAt: string;
}

export interface PartnerProviderLogsMeta {
  page: number;
  limit: number;
  total: number;
  hasMore: boolean;
}

export interface PartnerProviderLogsResponse {
  data: PartnerProviderLog[];
  meta: PartnerProviderLogsMeta;
}

export interface PartnerProviderLogsFilters {
  provider?: string;
  eventType?: string;
  status?: string;
  level?: string;
  operation?: string;
  dateFrom?: string;
  dateTo?: string;
  page?: number;
  limit?: number;
}
